
import React from 'react';
import { Accordion } from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { BenefitItem } from './BenefitItem';
import { Benefit } from '@/lib/supabase/products';

interface BenefitsListProps {
  benefits: Benefit[];
  updateBenefit: (id: string, field: keyof Benefit, value: any) => void;
  removeBenefit: (id: string) => void;
  toggleVisibility: (id: string) => void;
  addNewBenefit: () => void;
}

export const BenefitsList = ({ 
  benefits, 
  updateBenefit, 
  removeBenefit, 
  toggleVisibility, 
  addNewBenefit 
}: BenefitsListProps) => {
  if (benefits.length === 0) {
    return (
      <div className="py-8 text-center text-gray-500 dark:text-gray-400">
        <p>Aucun bénéfice ajouté</p>
        <p className="text-sm">Ajoutez des bénéfices pour mettre en valeur votre produit</p>
        <Button onClick={addNewBenefit} className="w-full mt-4" variant="outline">
          <Plus className="h-4 w-4 mr-2" />
          Ajouter un bénéfice
        </Button>
      </div>
    );
  }

  return (
    <>
      <Accordion type="multiple" className="space-y-2">
        {benefits.map((benefit) => (
          <BenefitItem
            key={benefit.id}
            benefit={benefit}
            updateBenefit={updateBenefit}
            removeBenefit={removeBenefit}
            toggleVisibility={toggleVisibility}
          />
        ))}
      </Accordion>

      <Button 
        onClick={addNewBenefit} 
        className="w-full mt-4 bg-[#1e1e2d] text-white dark:bg-[#1e1e2d] dark:text-white border dark:border-gray-700 hover:bg-[#252a41] dark:hover:bg-[#252a41]"
      >
        <Plus className="h-4 w-4 mr-2" />
        Ajouter un bénéfice
      </Button>
    </>
  );
};
